import React from 'react';
import { useNavigate } from 'react-router-dom';
import { maheshPhotographyVendor } from '../data/a2zRentalCatalog';
import './EquipmentRentalsPage.css';
import './MaheshPhotographyDronePage.css';

const SERVICES = [
  'Production stills and unit photography',
  'Aerial cinematography and survey-style captures (where permitted)',
  'Event and corporate coverage',
  'Behind-the-scenes and promotional packages',
];

export default function MaheshPhotographyDronePage() {
  const navigate = useNavigate();
  const digits = String(maheshPhotographyVendor.phone || '').replace(/\D/g, '');
  const telHref = digits ? `tel:+91${digits}` : null;

  return (
    <div className="equipment-page">
      <div className="equipment-page-inner">
        <div className="equipment-back-row">
          <button type="button" className="equipment-back" onClick={() => navigate('/production-sourcing')}>
            ← All suppliers
          </button>
          <span className="equipment-back-sep" aria-hidden>
            ·
          </span>
          <button type="button" className="equipment-back" onClick={() => navigate('/')}>
            Home
          </button>
        </div>

        <header className="equipment-vendor-card">
          <div className="equipment-vendor-header-row">
            <div className="equipment-vendor-main">
              <h1>{maheshPhotographyVendor.name}</h1>
              <p className="equipment-vendor-meta">{maheshPhotographyVendor.address}</p>
              {telHref ? (
                <p className="equipment-vendor-meta">
                  Phone:{' '}
                  <a href={telHref}>{maheshPhotographyVendor.phone}</a>
                </p>
              ) : (
                <p className="equipment-vendor-meta">Phone: contact the vendor for quotes and availability.</p>
              )}
              <p className="equipment-disclaimer">
                Services, permits, and rates are agreed directly with the supplier. Confirm drone regulations for your shoot
                location.
              </p>
            </div>
          </div>
        </header>

        <section className="equipment-section mahesh-services-section">
          <h2 className="equipment-section-title">Services</h2>
          <ul className="mahesh-services-list">
            {SERVICES.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
